import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

export const getOpenedPages = (state: RootState) => state.openedPages;

export const getOpenedClientsPage = createSelector([getOpenedPages], (page) => page.openedClientsPage);
export const getOpenedVendorsPage = createSelector([getOpenedPages], (page) => page.openedVendorsPage);
export const getOpenedAssetsPage = createSelector([getOpenedPages], (page) => page.openedAssetsPage);
export const getPreviousURLTeamMembers = createSelector([getOpenedPages], (page) => page.previousURLTeamMembers);

export const getOpenedWashroomLogsPage = createSelector([getOpenedPages], (page) => page.openedWashroomLogsPage);
